import adminService from "../services/admin.service";

export const listJobData = (cycle_id) => (dispatch) => {
  return adminService.listJobData(cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_JOB_DATA_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listTargetGroup = (cycle_id) => (dispatch) => {
  return adminService.listTargetGroup(cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_TARGET_GROUP",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalLibrary = (cycle_id) => (dispatch) => {
  return adminService.listGoalLibrary(cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIBRARY",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listEvaluateType = () => (dispatch) => {
  return adminService.listEvaluateType().then(
    (response) => {
      dispatch({
        type: "SET_EVALUATE_TYPE",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalCategory = (competencyFormSelectValue) => (dispatch) => {
  return adminService.listGoalCategory(competencyFormSelectValue).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_CATEGORY",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalProgressGroup = (competencyFormSelectValue) => (dispatch) => {
  return adminService.listGoalProgressGroup(competencyFormSelectValue).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_PROGRESS_GROUP",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalProgress = (serial) => (dispatch) => {
  return adminService.listGoalProgress(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalGroup = (serial) => (dispatch) => {
  return adminService.listGoalGroup(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIBRARY_GROUP",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalLibraryGoalItem = (serial) => (dispatch) => {
  return adminService.listGoalLibraryGoalItem(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIBRARY_ITEM",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalLibraryGoalItemByGroup = (serial) => (dispatch) => {
  return adminService.listGoalLibraryGoalItemByGroup(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIBRARY_ITEM",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listGoalSubGroup = (serial) => (dispatch) => {
  return adminService.listGoalSubGroup(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_SUB_GROUP",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listCycle = (opt = {}) => (dispatch) => {
  return adminService.listCycle(opt).then(
    (response) => {
      dispatch({
        type: "SET_CYCLE_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const detailJobData = (serial, cycle_id) => (dispatch) => {
  return adminService.detailJobData(serial, cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_JOB_DATA_DETAIL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listPosition = (cycle_id) => (dispatch) => {
  return adminService.listPosition(cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_POSITION_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const detailPosition = (serial) => (dispatch) => {
  return adminService.detailPosition(serial).then(
    (response) => {
      dispatch({
        type: "SET_POSITION_DETAIL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const currentEmployees = (serial) => (dispatch) => {
  return adminService.currentEmployees(serial).then(
    (response) => {
      dispatch({
        type: "SET_CURRENT_EMPLOYEES",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const listEvaluationJoruney = (id) => (dispatch) => {
  return adminService.listEvaluationJoruney(id).then(
    (response) => {
      dispatch({
        type: "SET_EVALUATE_JOURNEY",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
